import { render, staticRenderFns } from "./MediationProcess.vue?vue&type=template&id=3ab19230"
import script from "./MediationProcess.vue?vue&type=script&lang=js"
export * from "./MediationProcess.vue?vue&type=script&lang=js"
import style0 from "./MediationProcess.vue?vue&type=style&index=0&id=3ab19230&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports